import { MasterMedicine } from '../../apis/master-medicines/types';
import { MasterMedicineSelectorOption } from './interface';

export function isString(value: any): value is string {
  return typeof value === 'string';
}

export function getSelectedOption(selectedMasterMedicinesId: string, masterMedicines: MasterMedicine[]) {
  const selectedMasterMedicines = findSelectedMasterMedicinesById(masterMedicines, selectedMasterMedicinesId);

  return selectedMasterMedicines.map(createOption);
}

function findSelectedMasterMedicinesById(masterMedicines: MasterMedicine[], selectedMasterMedicinesId: string) {
  return masterMedicines.filter(masterMedicine => masterMedicine._id === selectedMasterMedicinesId);
}

export function createOptions(questionnaires: MasterMedicine[], selectedMasterMedicine?: MasterMedicine | null) {
  const options: MasterMedicineSelectorOption[] = [createEmptyOption()];

  if (selectedMasterMedicine) {
    options.push(createOption(selectedMasterMedicine));
  }

  return options.concat(mapMasterMedicinesToOptions(questionnaires));
}

function mapMasterMedicinesToOptions(masterMedicines: MasterMedicine[]): MasterMedicineSelectorOption[] {
  return masterMedicines.map(createOption);
}

function createOption(condition: MasterMedicine): MasterMedicineSelectorOption {
  return {
    value: condition._id,
    label: condition.name
  };
}

function createEmptyOption(): MasterMedicineSelectorOption {
  return {
    value: null,
    label: 'None'
  };
}
